import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

import ApiVersionConstants from "../constants/api-version-constants";
import { ExcelExport } from "../models/ExcelExport";

@Injectable({
  providedIn: "root",
})
export class QuoteService {
  private baseUrl = `${environment.apiConfig.uri}/${ApiVersionConstants.V_2}/quote`;

  constructor(private http: HttpClient) {}

  public exportToExcelAsync(excelExport: ExcelExport): Observable<Blob> {
    const url = `${this.baseUrl}/downloadExcel`;
    return this.http.post(url, excelExport, { responseType: "blob" });
  }
}
